import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { createPortal } from 'react-dom'
import { Button, Dropdown, Modal } from 'react-bootstrap'

import { AppContext } from '../../../context'

import CompleteProfilePopover from '../CompleteProfilePopover'

import userDefault from '../../../assets/img/Explore-w-Imray-user-image-default@2x.jpg'
import Slide from '../../ui/Slide'
import { API, deleteApiData, getApiData, postApiData } from '../../../api'
import ShareOnModal from './ShareOnModal'
import type {
  ILocationComment,
  IUserData,
  IUserToFollow
} from '../../../typings/common'
import {
  buildCommentStatus,
  getUserImageUrl,
  stringIsNullOrEmpty
} from '../../../utils/mapHelpers.js'

import Skeleton from 'react-loading-skeleton'
import { AuthContext } from '../../auth/authProvider'

interface ProfileData extends IUserData {
  isFollowed?: boolean
}

interface FullBodyShown {
  [key: string]: boolean
}

interface SocialPost {
  id: string
  longitude: number
  latitude: number
  userId: string
  user: {
    firstName: string
    lastName: string
    imageId: string
  }
  created: string
  title: string
  body: string
  images: string
  isEditable: boolean
  isLiked: boolean
  likeCount: number
  permalink: string
}

interface LikedPosts {
  [key: string]: boolean
}

const UserProfile: React.FC = () => {
  const socialURL = process.env.REACT_APP_SOCIAL_URL
  const exploreURL = process.env.REACT_APP_EXPLORE_URL
  const cloud = process.env.REACT_APP_CLOUDINARY_CLOUD

  const userProfileUrl = `/edit-profile/`

  const [isForOtherUser, setIsForOtherUser] = useState<boolean | null>(null)

  const [showSocialFeed, setShowSocialFeed] = useState(false)
  const [data, setData] = useState<ProfileData | null>(null)
  const [socialPosts, setSocialPosts] = useState([])
  const [postsLoaded, setPostsLoaded] = useState(false)
  const [fullBodyShown, setFullBodyShown] = useState<FullBodyShown>({})
  const [showMoreButtonId, setShowMoreButtonId] = useState('')
  const [shareonData, setShareonData] = useState({
    title: '',
    url: ''
  })
  const [likedPosts, setLikedPosts] = useState<LikedPosts>({})
  const [feedTitle, setFeedTitle] = useState('Latest Posts')
  const [selectedTab, setSelectedTab] = useState('posts')
  const [contributions, setContributions] = useState<ILocationComment[]>([])
  const [isFindButtonActive, setIsFindButtonActive] = useState(false)
  const [usersToFollow, setUsersToFollow] = useState<IUserToFollow[]>([])
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [isFollowed, setIsFollowed] = useState(false)
  const [postIdToDelete, setPostIdToDelete] = useState('')

  const [fill, setFill] = useState(0)
  const [isShrinkProfile, setIsShrinkProfile] = useState(false)
  const isLoadingProfile = isForOtherUser === null

  const {
    userData,
    popoverData,
    setPopoverData,
    activePopover,
    setLocationToView,
    onEnlargeModalOpen,
    setResetHighlightedPin,
    setShouldResetSocialPins
  } = useContext(AppContext)

  const authContext = useContext(AuthContext)
  const isActive = activePopover === 'profile'
  const currentUserId = userData?.id || ''

  const clickedPostId = popoverData?.postId || ''
  const userId = userData?.id || ''

  const hasBoatInfo =
    userData?.profile_boat_name ||
    userData?.profile_boat_type ||
    data?.profile_boat_model ||
    data?.profile_boat_year ||
    data?.profile_boat_length ||
    data?.profile_boat_length

  const [imageUrl, setImageUrl] = useState()

  // TODO later
  // use my user from context instead of fetching it everytime - but double check it returns the same data
  // the same for other users, don't fetch them all the time, store in a context
  // test clicking on a contribution

  useEffect(() => {
    // this is a workaround for user-profile-overlay being scrolled to the bottom
    function handleScroll() {
      const list = document.getElementById('user-profile-overlay')

      if (!list) {
        return
      }
      list.scrollTop = 0
    }
    if (hasBoatInfo) {
      const list = document.getElementById('user-profile-overlay')

      list?.addEventListener('scroll', handleScroll)
      return () => {
        list?.removeEventListener('scroll', handleScroll)
      }
    }
  }, [hasBoatInfo])

  useEffect(() => {
    if (isActive) {
      setSocialPosts([])
      setContributions([])
      setLikedPosts({})

      if (selectedTab === 'posts') {
        /*getAndSetSocialPosts(idToUse)*/
      } else if (selectedTab === 'following') {
        const url = `${socialURL}api/socialPost/getFollowedSocialPosts`
        /*getAndSetPosts(url)*/
      } else {
        /*getAndSetContributions(idToUse)*/
      }
    } else {
      setIsForOtherUser(null)
      setSocialPosts([])
      setContributions([])
      setIsFindButtonActive(false)
      setSelectedTab('posts')
    }
  }, [selectedTab, isActive, isForOtherUser, userId])

  useEffect(() => {
    const getImageSource = async () => {
      const profileImageKey = userData?.photo
      try {
        const imageRes = await API.get('/image', {
          params: { key: profileImageKey }
        })
        setImageUrl(imageRes.data.message.base64image)
      } catch (e) {
        setImageUrl(undefined)
      }
    }

    getImageSource().then()

    setData(null)
    setIsForOtherUser(null)
    setPostsLoaded(false)
    setIsShrinkProfile(false)
    setSelectedTab('posts')
  }, [userId])

  useEffect(() => {
    if (clickedPostId && postsLoaded && socialPosts.length > 0) {
      const element = document.getElementById(clickedPostId)

      // need timeout to wait for the list to be rendered
      setTimeout(() => {
        element?.scrollIntoView()
      }, 300)
    }
  }, [clickedPostId, postsLoaded, socialPosts.length])

  useEffect(() => {
    const showUserProfile = async () => {
      const res = await authContext.getUserProfile()

      let forOtherUser = false

      if (res.data !== null) {
        setIsForOtherUser(forOtherUser)
        setData(res?.data?.message)
        setIsFollowed(false)

        // not from other user's pin (profile or from my pin)
        setShowSocialFeed(true)
        /*        if (data.userIsMe ?? true) {
          getAndSetSocialPosts(undefined, undefined)
        } else if (forOtherUser) {
          // from other user's pin
          setIsFindButtonActive(false)

          getAndSetSocialPosts(userId, 'Latest Posts')
        }*/
      }
    }

    if (isActive) {
      showUserProfile().then()
    }
  }, [userId, clickedPostId, isActive])

  useEffect(() => {
    function handleScroll() {
      const list = document.getElementById('social-post-list-container')

      if (!list) {
        return
      }
      const scrollTop = list.scrollTop

      if (scrollTop > 1 && !isShrinkProfile) {
        const windowHeight = window.innerHeight
        const calcHeight = 185
        let newFill = windowHeight - calcHeight

        Array.from(list.children).some(child => {
          newFill -= (child as HTMLElement).offsetHeight
          if (newFill <= 0) {
            newFill = 0
            return true // break out
          }
          return false
        })

        setFill(newFill)
        setIsShrinkProfile(true)
        list.scrollTop = 1
      } else if (scrollTop < 1 && isShrinkProfile) {
        setIsShrinkProfile(false)
        setFill(0)
      }
    }
    if (isActive) {
      const list = document.getElementById('social-post-list-container')

      list?.addEventListener('scroll', handleScroll)
      return () => {
        list?.removeEventListener('scroll', handleScroll)
      }
    }
  }, [
    isShrinkProfile,
    selectedTab,
    isActive,
    postsLoaded,
    socialPosts.length,
    !isFindButtonActive
  ])

  async function getAndSetUserContributions(url: string, feedTitle = '') {
    try {
      const locationComments = await getApiData(url)
      setContributions(locationComments || [])
      setPostsLoaded(true)

      if (!stringIsNullOrEmpty(feedTitle)) {
        setFeedTitle(feedTitle)
      }
    } catch (error) {
      const message = `Error getting location comments for user from server at url - ${url} - ${error}`
      console.log(message)
    }
  }

  function likeSocialPost(id: string) {
    const url = `${socialURL}api/socialPostLike/like/${id}`

    postApiData(
      url,
      null,
      function () {},
      function () {
        // remove like if not successful
        const newLikedPosts = { ...likedPosts }
        delete newLikedPosts[id]
        setLikedPosts(newLikedPosts)
      }
    )
  }

  async function getAndSetPosts(url = '', feedTitle = '') {
    try {
      const socialPosts = await getApiData(url)

      setSocialPosts(socialPosts)
      setPostsLoaded(true)
      if (!stringIsNullOrEmpty(feedTitle)) {
        setFeedTitle(feedTitle)
        setShowSocialFeed(true)
      } else {
        // setFeedTitle('')
        // setShowSocialFeed(false)
      }
    } catch (error) {
      const message = `Error getting social posts from server at url - ${url} - ${error}`
      console.log(message)
    }
  }

  function getAndSetSocialPosts(userId = '', feedTitle = '') {
    const url = !stringIsNullOrEmpty(userId)
      ? `${socialURL}api/socialPost/getSocialPostsByUserId/${userId}`
      : `${socialURL}api/socialPost/getUserSocialPosts`
    getAndSetPosts(url, feedTitle)
  }

  function deleteSocialPost() {
    const url = `${socialURL}api/socialPost/delete/${postIdToDelete}`

    axios({
      method: 'delete',
      url: url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        getAndSetSocialPosts() // only deleting own posts
        setShouldResetSocialPins(true)
        setPostIdToDelete('')
      })
      .catch(function () {
        console.log('Error deleting post.')
      })
  }

  function getSocialPostListItemHTML({
    id,
    longitude,
    latitude,
    userId: postUserId,
    user,
    created: createdDate,
    title,
    body,
    images,
    isEditable,
    isLiked: isLikedDb,
    likeCount = 0,
    permalink
  }: SocialPost) {
    const author = `${user.firstName} ${user.lastName}`
    const bodyTrimmed =
      body.length > 265 ? body.substring(0, 265) + '...' : body
    const readButtonVisibility = body.length > 265

    const formattedDate = new Date(Date.parse(createdDate)).toLocaleDateString(
      'en-GB',
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }
    )

    let hasImagesClass = ''
    let splitImages: string[] = []

    if (!stringIsNullOrEmpty(images)) {
      hasImagesClass = 'has-images'
      splitImages = images.split(';')
      splitImages = splitImages.filter(element => {
        return element !== null && element !== undefined && element !== ''
      })
    }

    const isCurrUser = postUserId === currentUserId
    const isLiked = isLikedDb || likedPosts[id]

    const likeStatusClass = isLiked ? 'material-symbols-outlined' : ''
    const likeCountDisplayValue = likeCount + (likedPosts[id] ? 1 : 0) || ''

    const showFullBody = fullBodyShown[id]
    const isPostMoreButtonVisible = showMoreButtonId === id

    return (
      <div
        id={id}
        className={`ug-post-list-item ${hasImagesClass}`}
        onClick={() => {
          setLocationToView({ id: id, layer: 'social' as const })
        }}
        key={id}
      >
        <div>
          <div className="ug-post-profile-info-row">
            <div>
              <img className="link-to-profile" src={imageUrl} />
              <div
                onClick={e => {
                  // e.stopPropagation()
                  // setResetHighlightedPin(true)
                  // setPopoverData({
                  //   userId: id,
                  //   postId: ''
                  // })
                }}
              >
                <h5 className="link-to-profile" data-profile-id={userId}>
                  {author}
                </h5>
                <p>{formattedDate}</p>
              </div>
            </div>
            <div>
              <Dropdown
                drop="down"
                onToggle={() =>
                  setShowMoreButtonId(isPostMoreButtonVisible ? '' : id)
                }
                // this is done on purpose in order to override the default bsPrefix="dropdown"
                bsPrefix=" "
              >
                <Dropdown.Toggle
                  id="moreDropdown"
                  bsPrefix="ug-post-more-button btn-pill no-fill no-label"
                  as="a"
                >
                  <span className="material-icons">more_horiz</span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  id="social-post-dropup-menu"
                  show={isPostMoreButtonVisible}
                >
                  <Dropdown.Item
                    bsPrefix="dropdown-item post-more-item"
                    onClick={e => {
                      e.stopPropagation()
                      const postId = id

                      setShowMoreButtonId('')

                      if (isCurrUser) {
                        setPostIdToDelete(postId)
                      } else {
                        const formUrl = `https://share.hsforms.com/1rBXdJMZWS8e863ADLf0tQw4udgz?TICKET.postid=${postId}`
                        const win = window.open(formUrl, '_blank')
                        if (win) {
                          win.focus()
                        } else {
                          alert('Please allow popups for this website')
                        }
                      }
                    }}
                  >
                    <span className="material-icons">
                      {isCurrUser ? 'delete_outline' : 'outlined_flag'}
                    </span>
                    {isCurrUser
                      ? 'Delete post'
                      : 'Report inappropriate content'}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <span className="ug-post-title">{title}</span>
          <div className="ug-post-images">
            <div className="social-post-image-collection">
              {splitImages.map(imageId => {
                const res =
                  splitImages.length == 1 ? 'h_380,w_688' : 'h_240,w_341'
                const socialImagesBaseURL = `https://res.cloudinary.com/${cloud}/image/upload/c_limit,${res}/`

                return (
                  <div key={imageId}>
                    <img
                      className="expandable-image social-post-image"
                      alt={title}
                      title={title}
                      src={socialImagesBaseURL + imageId}
                      onClick={e => {
                        e.stopPropagation()
                        onEnlargeModalOpen(socialImagesBaseURL + imageId, title)
                      }}
                    />
                  </div>
                )
              })}
            </div>
          </div>
          <p className={`ug-post-body-preview ${showFullBody ? 'hidden' : ''}`}>
            {bodyTrimmed}
          </p>
          <p className={`ug-post-body ${showFullBody ? '' : 'hidden'}`}>
            {body}
          </p>
        </div>
        <div className="ug-post-interactions">
          <a
            className={`${
              showFullBody ? 'ug-post-collapse-button' : 'ug-post-read-button'
            } btn-pill small-pill ${readButtonVisibility ? '' : 'invisible'}`}
            onClick={e => {
              e.stopPropagation()

              setFullBodyShown(state => ({
                ...state,
                [id]: !showFullBody
              }))
            }}
            style={{
              display: readButtonVisibility ? 'inline' : ''
            }}
          >
            {showFullBody ? 'Collapse' : 'Read'}
          </a>
          <div className="dropup inline">
            <a
              className="ug-post-more-button btn-pill like-post"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={e => {
                e.stopPropagation()

                const postId = id
                const isCurrentUser = isCurrUser

                if (isCurrentUser || isLiked) return
                // Update UI immediately so that there is no delay for the user

                setLikedPosts(state => ({
                  ...state,
                  [postId]: true
                }))

                likeSocialPost(postId)
              }}
            >
              <span
                className={`like-post-button material-icons-outlined ${likeStatusClass}`}
              >
                thumb_up
              </span>
              <span className="like-post-count">{likeCountDisplayValue}</span>
            </a>
            <a
              className="ug-post-more-button btn-pill share-post"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={e => {
                e.stopPropagation()

                const postTitle = title
                const returnUrl = `${exploreURL}preview/?postLink=${permalink}`

                setShareonData({ url: returnUrl, title: postTitle })
              }}
            >
              <span className="share-post-button material-icons">share</span>
            </a>
          </div>
        </div>
      </div>
    )
  }

  function getLocationCommentListItemHTML(locationComment: ILocationComment) {
    const {
      bookNodeId,
      created: createdDate,
      bookNode: { name: bookNodeTitle },
      comment: commentBody,
      images: commentImages,
      bookTimestamp,
      id: commentId
    } = locationComment

    const status: JSX.Element = buildCommentStatus(locationComment)

    const author = `${data !== null ? userData?.first_name : ''} ${
      data !== null ? userData?.last_name : ''
    }`

    const bodyTrimmed =
      commentBody.length > 265
        ? commentBody.substring(0, 265) + '...'
        : commentBody
    const formattedDate = new Date(Date.parse(createdDate)).toLocaleDateString(
      'en-GB',
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }
    )
    let profilePictureURL = userData?.photo ? userData?.photo : userDefault

    let imagesHtml: JSX.Element[] = []
    let hasImagesClass = ''

    if (!stringIsNullOrEmpty(commentImages)) {
      hasImagesClass = 'has-images'
      let splitImages = commentImages.split(';')
      splitImages = splitImages.filter(function (element) {
        return element !== null && element !== undefined && element !== ''
      })

      const res = splitImages.length == 1 ? 'h_380,w_688' : 'h_240,w_341'
      const socialImagesBaseURL = `https://res.cloudinary.com/${cloud}/image/upload/c_limit,${res}/`

      splitImages.forEach(imageId => {
        let imageHtml = (
          <div key={imageId}>
            <img
              className="expandable-image social-post-image"
              alt={bookNodeTitle}
              title={bookNodeTitle}
              src={socialImagesBaseURL + imageId}
              onClick={e => {
                e.stopPropagation()
                onEnlargeModalOpen(socialImagesBaseURL + imageId, bookNodeTitle)
              }}
            />
          </div>
        )
        imagesHtml.push(imageHtml)
      })
    }

    return (
      <div
        id={bookNodeId}
        className={`ug-comment-list-item ${hasImagesClass}`}
        key={commentId}
        onClick={() => {
          setLocationToView({
            id: bookNodeId,
            layer: 'places'
          })
        }}
      >
        <div id="comment-item-container">
          <div
            className="ug-comment-profile-info-row"
            onClick={e => {
              e.stopPropagation()
              setResetHighlightedPin(true)

              // TODO later: what does this even do?
              // i think it can be removed as we are already in the profile page
              // if (data?.id) {
              //   setPopoverData({
              //     userId: data.id,
              //     postId: ''
              //   })
              // }
            }}
          >
            <img className="link-to-profile" src={profilePictureURL} />
            <div>
              <h5 className="link-to-profile">{author}</h5>
              <p>{formattedDate}</p>
            </div>
          </div>
          <span className="ug-post-title">{bookNodeTitle}</span>
          <div className="ug-post-images">
            <div className="social-post-image-collection">{imagesHtml}</div>
          </div>
          <p className="ug-post-body-preview">{bodyTrimmed}</p>
          <p className="ug-post-body hidden">{commentBody}</p>
        </div>
        <div
          id="location-comment-status"
          className={`ug-post-interactions ${
            bookTimestamp !== null &&
            bookTimestamp !== undefined &&
            bookTimestamp !== ''
              ? 'has-timestamp'
              : ''
          }`}
        >
          {status}
        </div>
        {bookTimestamp && (
          <div id="location-comment-book-timestamp">{bookTimestamp}</div>
        )}
      </div>
    )
  }

  async function getUserFollowList() {
    setIsDataLoaded(false)
    setUsersToFollow([])
    const url = `${socialURL}api/userProfile/getUsersWithCompletedProfiles`
    try {
      const users = await getApiData(url)

      if (users !== null && users !== undefined && users.length > 0) {
        setUsersToFollow(users)
      }
    } catch (error) {
      const message = `Error retrieving user data from the server at url - ${url} - ${error}`
      console.log(message)
    }
    setIsDataLoaded(true)
  }

  async function followUser(id: string) {
    const url = `${socialURL}api/userFollow/followUser/${id}`

    try {
      await postApiData(url, null)
      setUsersToFollow(usersToFollow =>
        usersToFollow.map(user =>
          user.id !== id ? user : { ...user, isFollowed: true }
        )
      )
    } catch (error) {
      const message = `Error following user at url - ${url} - ${error}`
      setIsFollowed(false)
      console.log(message)
    }
  }

  async function unfollowUser(id: string) {
    const url = `${socialURL}api/userFollow/unfollowUser/${id}`

    try {
      await deleteApiData(url)
      setUsersToFollow(usersToFollow =>
        usersToFollow.map(user =>
          user.id !== id ? user : { ...user, isFollowed: false }
        )
      )
    } catch (error) {
      const message = `Error unfollowing user at url - ${url} - ${error}`
      setIsFollowed(true)
      console.log(message)
    }
  }

  function followOrUnfollowButtonAction(isFollowing: boolean, userId: string) {
    if (!isFollowing) {
      followUser(userId)
    } else {
      unfollowUser(userId)
    }
  }

  function getUserListItemHTML(user: IUserToFollow) {
    const {
      id,
      firstName,
      lastName,
      boatName,
      currentPort,
      imageId,
      isFollowed
    } = user

    const subTitle =
      !stringIsNullOrEmpty(boatName) && !stringIsNullOrEmpty(currentPort)
        ? boatName + ', ' + currentPort
        : !stringIsNullOrEmpty(boatName) && stringIsNullOrEmpty(currentPort)
        ? boatName
        : stringIsNullOrEmpty(boatName) && !stringIsNullOrEmpty(currentPort)
        ? currentPort
        : ''
    const buttonIcon = isFollowed ? 'how_to_reg' : 'person_add'
    const buttonText = isFollowed ? 'Following' : 'Follow'
    const buttonClass = isFollowed ? 'following' : ''

    return (
      <div id={id} className="user-list-item" key={id}>
        <div className="user-list-item-body">
          <div className="user-profile-picture-row">
            <div>
              <img
                className="user-profile-picture"
                src={imageUrl ?? userDefault}
              />
              <div>
                <h5 className="user-list-item-name">
                  {firstName} {lastName}
                </h5>
                <span className="user-list-item-boat-and-port">{subTitle}</span>
              </div>
            </div>
            <a
              className={`follow-button btn-pill small-pill ${buttonClass}`}
              onClick={() => {
                followOrUnfollowButtonAction(isFollowed, id)
              }}
            >
              <span className="material-icons-outlined">{buttonIcon}</span>
              <span>{buttonText}</span>
            </a>
          </div>
        </div>
      </div>
    )
  }

  return (
    <AppContext.Consumer>
      {({
        activePopover,
        onTogglePopover,
        setResetHighlightedPin,
        isAuthenticated
      }) => (
        <>
          <Modal
            show={Boolean(postIdToDelete)}
            style={{ backgroundColor: 'transparent' }}
          >
            <Modal.Header style={{ display: 'block', borderBottom: 'none' }}>
              <Modal.Title as="h5">Delete social post</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this post?</Modal.Body>
            <Modal.Footer
              style={{ justifyContent: 'center', borderTop: 'none' }}
            >
              <Button variant="secondary" onClick={() => setPostIdToDelete('')}>
                Cancel
              </Button>
              <Button variant="primary" onClick={() => deleteSocialPost()}>
                Yes, delete my post
              </Button>
            </Modal.Footer>
          </Modal>
          {createPortal(
            <ShareOnModal
              url={shareonData.url}
              title={shareonData.title}
              onClose={() => {
                setShareonData({ url: '', title: '' })
              }}
            />,
            document.body
          )}
          {isAuthenticated ? (
            createPortal(
              <Slide
                id="user-profile-overlay"
                className="overlay overlay-left blurred-container"
                isVisible={activePopover === 'profile'}
              >
                <div
                  id="user-profile-container"
                  className={`${isShrinkProfile ? 'shrink-profile' : ''} ${
                    hasBoatInfo ? 'has-boat-info' : ''
                  }`}
                >
                  <div id="user-profile-header" className="card-header">
                    {isLoadingProfile ? (
                      <>
                        <a
                          id="user-profile-edit-button"
                          className="edit-button btn-pill"
                          style={{
                            display: ''
                          }}
                        >
                          <span className="material-icons-outlined">
                            &nbsp;
                          </span>
                          <span>
                            <Skeleton
                              width={35}
                              style={{
                                borderRadius: '20px'
                              }}
                            />
                          </span>
                        </a>
                        <a
                          className="close-button btn-pill no-fill no-label"
                          style={{
                            display: ''
                          }}
                        >
                          <span className="material-icons">&nbsp;</span>
                        </a>
                      </>
                    ) : (
                      <>
                        <div>
                          <a
                            href={userProfileUrl}
                            id="user-profile-edit-button"
                            className="edit-button btn-pill"
                            style={{
                              display:
                                !isLoadingProfile && !isForOtherUser
                                  ? ''
                                  : 'none'
                            }}
                          >
                            <span className="material-icons-outlined">
                              manage_accounts
                            </span>
                            <span>Edit</span>
                          </a>
                          <a
                            id="user-profile-back-button"
                            className="back-button btn-pill"
                            onClick={() => {
                              setIsForOtherUser(false)
                              setResetHighlightedPin(true)
                              setPopoverData({
                                userId: '',
                                postId: ''
                              })
                              setFeedTitle('')
                              setSelectedTab('posts')
                            }}
                            style={{
                              display:
                                !isLoadingProfile && isForOtherUser
                                  ? ''
                                  : 'none'
                            }}
                          >
                            <span className="material-icons-outlined">
                              arrow_back
                            </span>
                            <span>My profile</span>
                          </a>
                          <div id="current-user-reference">
                            <div>
                              <img
                                id="profile-picture"
                                src={getUserImageUrl(data, cloud)}
                              />
                            </div>
                            <div>
                              <h5 id="current-user">
                                {userData?.first_name} {userData?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <a
                          className="close-button btn-pill no-fill no-label"
                          onClick={() => {
                            onTogglePopover('')
                            setResetHighlightedPin(true)
                          }}
                          style={{
                            display:
                              isLoadingProfile || isForOtherUser ? 'none' : ''
                          }}
                        >
                          <span className="material-icons">clear</span>
                        </a>

                        <a
                          id="user-profile-follow-button"
                          className={`user-profile-follow-button btn-pill ${
                            isFollowed ? 'following' : ''
                          }`}
                          style={{
                            display:
                              !isLoadingProfile && isForOtherUser
                                ? 'flex'
                                : 'none'
                          }}
                          onClick={() => {
                            followOrUnfollowButtonAction(
                              isFollowed,
                              userData?.id?.toString() || ''
                            )
                            setIsFollowed(!isFollowed)
                          }}
                        >
                          <span className="material-icons-outlined">
                            {isFollowed ? 'how_to_reg' : 'person_add'}
                          </span>
                          <span>{isFollowed ? 'Following' : 'Follow'}</span>
                        </a>
                        <span id="user-profile-user-id">
                          {isForOtherUser && data?.id ? data!.id : ''}
                        </span>
                      </>
                    )}
                  </div>
                  <div className="panel-body">
                    <div
                      id="user-information-container"
                      className="card-body"
                      style={
                        hasBoatInfo
                          ? { borderRadius: '0 0 0 0' }
                          : { borderRadius: '0 0 6px 6px' }
                      }
                    >
                      <div id="profile-img-name">
                        <img
                          id="profile-picture"
                          src={
                            imageUrl
                              ? `data:image/png;base64, ${imageUrl}`
                              : userDefault
                          }
                        />
                        <h1 id="name">
                          {isLoadingProfile ? (
                            <Skeleton width={200} />
                          ) : (
                            `${userData?.first_name} ${userData?.last_name}`
                          )}
                        </h1>
                      </div>
                      <p id="bio">{userData?.profile_bio || ''}</p>
                      <p id="location">{userData?.profile_home_port || ''}</p>
                    </div>
                    <div id="transparent-border"></div>
                    <div
                      id="boat-info-container"
                      className=""
                      style={{ display: hasBoatInfo ? '' : 'none' }}
                    >
                      <div className="row align-items-start">
                        <div className="col boat-info-detail">
                          <p id="boat-name">
                            {userData?.profile_boat_name || ''}
                          </p>
                          <p>BOAT NAME</p>
                        </div>
                        <div className="col boat-info-detail">
                          <p id="boat-type">
                            {userData?.profile_boat_type || ''}
                          </p>
                          <p>BOAT TYPE</p>
                        </div>
                      </div>
                      <div className="row align-items-start">
                        <div className="col boat-info-detail">
                          <p id="boat-model">
                            {userData?.profile_boat_model || ''}
                          </p>
                          <p>MODEL</p>
                        </div>
                        <div className="col boat-info-detail">
                          <p id="boat-year">
                            {userData?.profile_boat_year || ''}
                          </p>
                          <p>YEAR</p>
                        </div>
                        <div className="col boat-info-detail">
                          <p id="boat-length">
                            {userData?.profile_boat_length || ''}
                          </p>
                          <p>LENGTH</p>
                        </div>
                        <div className="col boat-info-detail">
                          <p id="boat-draft">
                            {userData?.profile_boat_draft || ''}
                          </p>
                          <p>DRAFT</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    marginTop: '1rem',
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  Coming soon...
                </p>

                <div
                  style={{ display: 'none' }}
                  id="social-post-container"
                  className={isShrinkProfile ? 'shrink-profile' : ''}
                >
                  {isLoadingProfile && (
                    <div id="social-options">
                      <a id="dropdownMenuLink">
                        <Skeleton width={90} height={32} />
                      </a>

                      <div
                        id="social-feed-contributions-title"
                        style={{ display: 'block' }}
                      >
                        <Skeleton
                          width={75}
                          height={32}
                          style={{
                            borderRadius: '20px'
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {isForOtherUser && (
                    <div id="social-options">
                      <>
                        <div
                          id="social-feed-title"
                          className={showSocialFeed ? 'active' : 'inactive'}
                          style={{ display: 'block' }}
                          onClick={() => {
                            if (!showSocialFeed) {
                              setPostsLoaded(false)
                              setShowSocialFeed(true)
                              setSelectedTab('posts')
                            }
                          }}
                        >
                          {feedTitle}
                        </div>
                        <>
                          <span
                            id="social-feed-title-divider"
                            style={{ display: 'inline' }}
                          >
                            |
                          </span>
                          <div
                            id="social-feed-contributions-title"
                            className={showSocialFeed ? 'inactive' : 'active'}
                            style={{ display: 'block' }}
                            onClick={e => {
                              if (showSocialFeed) {
                                setPostsLoaded(false)
                                setShowSocialFeed(false)
                                setSelectedTab('contributions')
                              }
                            }}
                          >
                            Contributions
                          </div>
                        </>
                      </>
                    </div>
                  )}
                  {!isLoadingProfile && !isForOtherUser && (
                    <Dropdown
                      drop="down"
                      // this is done on purpose in order to override the default bsPrefix="dropdown"
                      bsPrefix=" "
                      id="social-options"
                    >
                      <Dropdown.Toggle
                        id="dropdownMenuLink"
                        as="a"
                        style={isFindButtonActive ? { display: 'none' } : {}}
                      >
                        {selectedTab === 'posts'
                          ? 'My Posts'
                          : selectedTab === 'following'
                          ? 'Following'
                          : selectedTab === 'contributions'
                          ? 'My Contributions'
                          : ''}
                      </Dropdown.Toggle>

                      <Dropdown.Menu id="social-options-dropdown-menu">
                        <Dropdown.Item
                          id="social-options-my-posts"
                          onClick={e => {
                            e.stopPropagation()
                            if (selectedTab !== 'posts') {
                              setPostsLoaded(false)
                              setResetHighlightedPin(true)
                              setSelectedTab('posts')
                            }
                          }}
                        >
                          My Posts
                        </Dropdown.Item>
                        <Dropdown.Item
                          id="social-options-following"
                          onClick={e => {
                            e.stopPropagation()
                            if (selectedTab !== 'following') {
                              setPostsLoaded(false)
                              setResetHighlightedPin(true)
                              setSelectedTab('following')
                            }
                          }}
                        >
                          Following
                        </Dropdown.Item>
                        <Dropdown.Item
                          id="social-options-contributions"
                          onClick={e => {
                            e.stopPropagation()
                            if (selectedTab !== 'contributions') {
                              setPostsLoaded(false)
                              setResetHighlightedPin(true)
                              setSelectedTab('contributions')
                            }
                          }}
                        >
                          My Contributions
                        </Dropdown.Item>
                      </Dropdown.Menu>

                      <div
                        id="social-feed-title"
                        className="inactive"
                        style={{
                          display: isFindButtonActive ? 'block' : 'none'
                        }}
                      >
                        Find people to follow
                      </div>

                      <a
                        className={`find-button btn-pill ${
                          isFindButtonActive ? 'active' : ''
                        }`}
                        onClick={() => {
                          const newValue = !isFindButtonActive
                          setIsFindButtonActive(newValue)

                          if (newValue) {
                            getUserFollowList()
                          } else {
                            getAndSetSocialPosts()
                          }
                        }}
                      >
                        <span className="material-icons-outlined">
                          people_alt
                        </span>
                        <span>Find</span>
                      </a>
                    </Dropdown>
                  )}

                  {isFindButtonActive && (
                    <div
                      id="user-list-container"
                      className="social-scroll-content"
                      style={{ display: 'block' }}
                    >
                      {isDataLoaded &&
                        usersToFollow.length > 0 &&
                        usersToFollow.map(user => getUserListItemHTML(user))}
                      {isDataLoaded && !usersToFollow.length && (
                        <div id="no-users-container">
                          <h2 id="no-users-message">No users found</h2>
                        </div>
                      )}
                    </div>
                  )}
                  {(selectedTab === 'posts' || selectedTab === 'following') &&
                    !isFindButtonActive &&
                    postsLoaded &&
                    !socialPosts.length && (
                      <div
                        id="no-social-posts-container"
                        className="social-scroll-content"
                        style={{ display: 'block' }}
                      >
                        <div>
                          <h3>No posts to display</h3>
                          <p>
                            We can't display any posts right now. This may be
                            because you haven't created any posts yet, you
                            aren't following any other users or due to a
                            temporary technical issue.
                          </p>
                        </div>
                      </div>
                    )}
                  {selectedTab === 'contributions' &&
                    !isFindButtonActive &&
                    postsLoaded &&
                    !contributions.length && (
                      <div
                        id="no-contributions-container"
                        className="social-scroll-content"
                        style={{
                          display:
                            selectedTab === 'contributions' ? 'block' : 'none'
                        }}
                      >
                        <div>
                          <h3>No contributions to display</h3>
                          {!isForOtherUser && (
                            <p>You haven't added any location comments yet.</p>
                          )}
                          {isForOtherUser && (
                            <p>
                              {userData?.first_name} hasn't added any location
                              comments yet.
                            </p>
                          )}
                        </div>
                      </div>
                    )}

                  {!postsLoaded && (
                    <div
                      id="social-post-list-container"
                      className="social-scroll-content"
                    >
                      <div className={`ug-post-list-item`}>
                        <div>
                          <div className="ug-post-profile-info-row">
                            <div>
                              <Skeleton circle />
                              <div>
                                <h5
                                  className="link-to-profile"
                                  data-profile-id={userId}
                                >
                                  <Skeleton />
                                </h5>
                                <p>
                                  <Skeleton />
                                </p>
                              </div>
                            </div>
                            <div>
                              <Skeleton />
                            </div>
                          </div>
                          <span className="ug-post-title">
                            <Skeleton />
                          </span>
                          <div className="ug-post-images">
                            <div className="social-post-image-collection">
                              <div>
                                <Skeleton />
                              </div>
                            </div>
                          </div>
                          <p className={`ug-post-body-preview`}>
                            <Skeleton count={3} />
                          </p>
                        </div>
                        <div className="ug-post-interactions">
                          <a
                            className={`btn-pill small-pill`}
                            style={{
                              display: 'inline'
                            }}
                          >
                            <Skeleton width={40} />
                          </a>
                          <div className="dropup inline">
                            <a className="ug-post-more-button btn-pill like-post">
                              <span
                                className={`like-post-button material-icons-outlined`}
                              >
                                &nbsp;
                              </span>
                              <span className="like-post-count">
                                <Skeleton />
                              </span>
                            </a>
                            <a
                              className="ug-post-more-button btn-pill share-post"
                              role="button"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span className="share-post-button material-icons">
                                &nbsp;
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div id="scroll-filler" style={{ height: `${fill}px` }} />
                    </div>
                  )}
                  {(selectedTab === 'posts' || selectedTab === 'following') &&
                    !isFindButtonActive &&
                    postsLoaded &&
                    socialPosts.length && (
                      <div
                        id="social-post-list-container"
                        className="social-scroll-content"
                      >
                        {socialPosts.map(post =>
                          getSocialPostListItemHTML(post)
                        )}
                        <div
                          id="scroll-filler"
                          style={{ height: `${fill}px` }}
                        />
                      </div>
                    )}
                  {selectedTab === 'contributions' &&
                    !isFindButtonActive &&
                    postsLoaded &&
                    contributions.length && (
                      <div
                        id="social-post-list-container"
                        className="social-scroll-content"
                      >
                        {contributions.map(locationComment =>
                          getLocationCommentListItemHTML(locationComment)
                        )}
                        <div
                          id="scroll-filler"
                          style={fill ? { height: `${fill}px` } : {}}
                        >
                          &nbsp;
                        </div>
                      </div>
                    )}
                </div>
              </Slide>,
              document.body
            )
          ) : (
            <CompleteProfilePopover />
          )}
        </>
      )}
    </AppContext.Consumer>
  )
}

export default UserProfile
